import { render, staticRenderFns } from "./CreateCompanySidebar.vue?vue&type=template&id=474f7bc1&"
import script from "./CreateCompanySidebar.vue?vue&type=script&lang=js&"
export * from "./CreateCompanySidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports